import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import LocalStorage from '../utils/localStorage';
import moment from 'moment';

class PaymentLogStore {
    // Properties

    @observable paymentStatuses = [
        { value: 'ALL', label: 'All' },
        { value: 'Not Paid', label: 'Not Paid' },
        { value: 'Paid', label: 'Paid' },
        { value: 'Failed', label: 'Failed' },
        { value: 'No payment required', label: 'No payment required' },
    ];

    @observable orderStatuses = [
        { value: 'ALL', label: 'All' },
        { value: 'Pending', label: 'Pending' },
        { value: 'Completed', label: 'Completed' },
    ];

    // Modal Create/Update Properties

    @observable showPaymentLogModal = false;
    @observable paymentLogTitle = '';

    @observable tabNameActiveKey = '1';
    @observable tabDescriptionActiveKey = '1';

    @observable paymentLog = null;
    @observable paymentLogs = [];

    @observable totalData = 0;

    // Helper Properties

    @observable paymentLogListLoading = false;
    @observable paymentLogModalLoading = false;

    // Initialization

    @action initPaymentLog(fromDate, endDate, currentPage, pageSize, paymentStatus, orderStatus, paymentTypeId, roomNo, lastName) {
        this.paymentLogListLoading = true;

        let fromDateTime = moment(fromDate).format('DD/MM/YYYY');
        let toDateTime = moment(endDate).format('DD/MM/YYYY');

        var request = {
            'fromDate': fromDateTime,
            'toDate': toDateTime,
            'currentPage': currentPage,
            'pageSize': pageSize,
            'paymentStatus': paymentStatus,
            'orderStatus': orderStatus,
            'paymentTypeId': paymentTypeId,
            'roomNo': roomNo,
            'lastName': lastName,
        };

        return ApiCaller.PaymentLogs.get(request).then(resp => {
            if (resp.isSuccess) {
                resp.model.map(m => {
                    return m.createdDate = moment(m.createdDate).format('DD/MM/yyyy HH:mm:ss');
                })
                this.paymentLogs = resp.model;
                this.totalData = resp.totalData;
                this.paymentLogListLoading = false;
            } else {
                this.paymentLogs = [];
                this.totalData = 0;
                this.paymentLogListLoading = false;
            }
        });
    }

    @action initUpdatePaymentLog(id) {
        this.paymentLogModalLoading = true;
        this.paymentLogTitle = 'Detail Payment Log';
        this.showPaymentLogModal = true;

        this.paymentLog = this.paymentLogs.find(fi => fi.id === id);
        this.paymentLogModalLoading = false;
    }

    @action create(paymentId, fnbTotal, request) {
        this.paymentLogListLoading = true;

        var request = {
            'paymentId': paymentId,
            'paymentStatus': 'Not Paid',
            'orderStatus': 'Pending',
            'roomNo': LocalStorage.Get('roomNo'),
            'lastName': LocalStorage.Get('lastName'),
            'customerId': LocalStorage.Get('customerId').toString(),
            'reservationNumber': LocalStorage.Get('reservationNumber'),
            'amount': parseFloat(fnbTotal.replace(/,/g, '')),
            'detail': JSON.stringify(request)
        };

        return ApiCaller.PaymentLogs.create(request);
    }

    // SET Properties

    @action setShowPaymentLogModal(value) {
        this.showPaymentLogModal = value;
        if (!value) {
            this.tabNameActiveKey = '1';
            this.tabDescriptionActiveKey = '1';
        }
    }

    @action setshowPaymentLogModal(value) {
        this.showPaymentLogModal = value;
    }
}

export default new PaymentLogStore()